import { render, staticRenderFns } from "./ReserveFundDetails.vue?vue&type=template&id=26ecde4e"
import script from "./ReserveFundDetails.vue?vue&type=script&lang=js"
export * from "./ReserveFundDetails.vue?vue&type=script&lang=js"
import style0 from "./ReserveFundDetails.vue?vue&type=style&index=0&id=26ecde4e&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports